import { createAction } from 'redux-actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { CustomAxios } from '../../axios';
import { UsageType } from '@weave/schema-gen-ts/dist/shared/phonedata/v1/phone_number.pb';
import type { UpdateOutboundCallerIDRequest } from '../../../apis/porting/porting.types';

export const clearAvailablePhoneNumbers = createAction('CLEAR_AVAILABLE_PHONE_NUMBERS');
export const purchasePhoneNumbers = createAction('PURCHASE_PHONE_NUMBERS');
export const newNumberSuccessMessages = createAction('NEW_NUMBER_SUCCESS_MESSAGES');
export const newNumberFailureMessages = createAction('NEW_NUMBER_FAILURE_MESSAGES');
export const addNewNumberSuccessMessage = createAction('ADD_NEW_NUMBER_SUCCESS_MESSAGE');
export const addNewNumberFailureMessage = createAction('ADD_NEW_NUMBER_FAILURE_MESSAGE');
export const purchasePhoneNumbersSuccess = createAction('PURCHASE_PHONE_NUMBERS_SUCCESS');

export const updateOutboundCallerId = function* (req: UpdateOutboundCallerIDRequest) {
  return yield call(
    CustomAxios.put,
    `phone-exp/phone-numbers/${req.phoneNumberId}/outbound-caller-id`,
    req
  );
};

export const purchaseSingleNumber = function* (num) {
  try {
    const purchaseRequest = {
      phone_number: num.phone_number,
      usage_type: num.usage_type,
      provider: num.provider,
      assignToDefaultCallRoute: num.assignToDefaultCallRoute,
    };

    const response = yield call(
      CustomAxios.post,
      'phone/number-service/v2/purchase',
      purchaseRequest
    );
    const phoneNumberId = response?.data?.number?.phoneNumber?.id;
    const purchasedNumber =
      response?.data?.number?.phoneNumber?.phoneNumber?.nationalNumber;

    if (num.enableOutboundCallerId) {
      if (phoneNumberId) {
        yield call(updateOutboundCallerId, {
          phoneNumberId,
          enabled: true,
        });
      } else {
        yield put(
          addNewNumberFailureMessage(
            `Could not enable outbound caller ID for purchased number ${num.phone_number}`
          )
        );
      }
    }

    yield put(addNewNumberSuccessMessage(`New Number (${purchasedNumber}) purchased.`));
    return { response: purchasedNumber };
  } catch {
    yield put(addNewNumberFailureMessage(`Could not purchase ${num.phone_number}`));
  }
  return;
};

export const purchaseTwilioPhoneNumbers = function* (action) {
  const {
    selectedNumbers,
    locationSlug,
    assignToDefaultCallRoute,
    enableOutboundCallerId,
  } = action.payload;

  // clear ui messages
  yield put(newNumberFailureMessages([]));
  yield put(newNumberSuccessMessages([]));

  // purchase phone numbers
  yield all(
    selectedNumbers.map((num: { phoneNumber: string; provider: string }) =>
      call(purchaseSingleNumber, {
        phone_number: num.phoneNumber,
        usage_type: UsageType.USAGE_TYPE_MAIN,
        provider: num.provider,
        assignToDefaultCallRoute: assignToDefaultCallRoute ?? false,
        enableOutboundCallerId: enableOutboundCallerId ?? false,
      })
    )
  );

  yield put(purchasePhoneNumbersSuccess());
};

export const purchasePhoneNumbersSaga = function* () {
  yield takeLatest(purchasePhoneNumbers.toString(), purchaseTwilioPhoneNumbers);
};
